import React from 'react';
import { scroller } from 'react-scroll';

import { lang } from '@ott/l10n';
import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import GradientButton from 'src/components/elements/GradientButton';

import metrics from 'src/utility/metrics';

import useIsWebview from 'src/hooks/useIsWebview';

import Planets from '../Planets';

import styles from './NFTHeading.scss';

const NFTHeading = () => {
  const { isDesktop } = useLayoutContext();
  const isWebview = useIsWebview();
  const webView = isWebview && !isDesktop;
  const webViewTarget = webView ? '_self' : '_blank';

  const onHowItWorksClick = () => {
    metrics('SOLAR_LANDING_REWARDS_BUTTON_HOW');
    scroller.scrollTo('explore-nft', { offset: -100 });
  };

  const onCheckCollectiblesClick = (event) => {
    metrics('SOLAR_LANDING_REWARDS_BUTTON_COL');
    event.preventDefault();
    const link = webView
      ? 'solartrip://solartrip.com/profile/achievements'
      : `/${lang}/profile/achievements`;
    window.open(link, webViewTarget);
  };

  return (
    <div className={styles.heading}>
      <FadeIn className={styles.title} delay={0}>
        <span className={styles.titleThin}>Craft your</span>
        {!isDesktop && <br />} Universe
      </FadeIn>
      <FadeIn className={styles.description}>
        <span>Embark on daring adventures and score collectible Planet rewards</span>
      </FadeIn>
      <FadeIn delay={1} className={styles.buttonsWrapper}>
        <GradientButton className={styles.headingButton} onClick={onHowItWorksClick}>
          How it works
        </GradientButton>
        <GradientButton
          className={styles.headingButton}
          onClick={(event) => onCheckCollectiblesClick(event)}
          darkGradient
        >
          Check my collectibles
        </GradientButton>
      </FadeIn>

      <Planets />
    </div>
  );
};

export default NFTHeading;
